var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"water-mark-show-history"}},[_c('div',{staticClass:"edit_history",attrs:{"id":"edit_history"}})])
}]

export { render, staticRenderFns }